import { __extends } from "../../../tslib/tslib.es6.mjs";
(function(_super) {
  __extends(MissingLocaleDataError, _super);
  function MissingLocaleDataError() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = "MISSING_LOCALE_DATA";
    return _this;
  }
  return MissingLocaleDataError;
})(Error);
function isMissingLocaleDataError(e) {
  return e.type === "MISSING_LOCALE_DATA";
}
export {
  isMissingLocaleDataError
};
